import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { billingStatus } from "@/auth";
import { AuthShell } from "@/components/AuthShell";

export default function PaymentResult({ success }) {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState(success ? "checking" : "cancel");
  const [plan, setPlan] = useState("");

  useEffect(() => {
    if (!success || !sessionId) return;
    let tries = 0; let timer;
    const poll = async () => {
      try {
        const r = await billingStatus(sessionId);
        if (r.payment_status === "paid") { setPlan(r.plan); return setState("paid"); }
        if (["failed", "expired"].includes(r.payment_status)) return setState("failed");
      } catch { /* keep polling */ }
      if (++tries < 10) timer = setTimeout(poll, 2000); else setState("timeout");
    };
    poll();
    return () => clearTimeout(timer);
  }, [success, sessionId]);

  const body = {
    checking: { icon: <Loader2 className="h-10 w-10 animate-spin text-orange-400" />, title: "Confirming your payment…", text: "This takes a few seconds." },
    paid: { icon: <CheckCircle2 className="h-10 w-10 text-emerald-400" />, title: "You're upgraded!", text: `Your company is now on the ${plan ? plan[0].toUpperCase() + plan.slice(1) : "new"} plan. New seat and registration limits apply immediately.` },
    failed: { icon: <XCircle className="h-10 w-10 text-rose-400" />, title: "Payment didn't complete", text: "No charge was made. You can try again from Billing." },
    timeout: { icon: <Loader2 className="h-10 w-10 text-amber-400" />, title: "Still processing", text: "Your payment is being confirmed. Check Billing in a minute — your plan will update automatically." },
    cancel: { icon: <XCircle className="h-10 w-10 text-slate-400" />, title: "Checkout cancelled", text: "No charge was made. Your current plan is unchanged." },
  }[state];

  return (
    <AuthShell testId="payment-result" title={body.title} subtitle={body.text}>
      <div className="flex justify-center py-4">{body.icon}</div>
      <Link data-testid="payment-back-link" to="/" className="flex w-full items-center justify-center rounded-xl bg-orange-600 py-2.5 font-semibold text-white hover:bg-orange-500">Back to dashboard</Link>
    </AuthShell>
  );
}
